export enum NdviHomogeneityLevel {
    HOMOGENEOUS = "homogeneous",
    HETEROGENEOUS = "heterogeneous",
    HIGHLY_HETEROGENEOUS = "highly_heterogeneous",
    UNDEFINED = "undefined"
}